import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Fintech App">
                <h1>Fintech Software Development Services</h1>
              </div>
              <div className="banner_content">
                <p>
                  As the leading FinTech software development company, our
                  digital banking and investment solutions help businesses turn
                  their traditional financial services into cutting-edge space.
                  Using pioneering technologies, like AI/ML, IoT, and
                  blockchain, our developers guarantee unmatched creativity and
                  efficiency in the final product.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
